export default calendarEvent => typeof calendarEvent.calendarEventSequence !== 'undefined'
    && (!!calendarEvent.calendarEventSequence.id || !!calendarEvent.calendarEventSequence.sequenceEndDate
      || !!calendarEvent.calendarEventSequence.intervalValue || !!calendarEvent.calendarEventSequence.intervalType)
